module.exports = __webpack_public_path__ + "media/zen_me_shuo.7f4dd429.mp3";